import { Card, CardActionArea, Typography } from '@mui/material'

/** One of the equal-weight access options shown after the account form (code vs. purchase). */
export function RegistrationChoiceOption({
  title,
  description,
  onClick,
}: {
  title: string
  description?: string
  onClick: () => void
}) {
  return (
    <Card variant="outlined">
      <CardActionArea onClick={onClick} sx={{ p: 2 }}>
        <Typography variant="subtitle1" fontWeight={600} color="secondary.main">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </CardActionArea>
    </Card>
  )
}
